import { DateInput } from "@/modules/common/components";

import { FilterFieldRendererProps } from "../types";

const PeriodFilterField = ({ field, values, onChangeField }: FilterFieldRendererProps) => {
  const inputs = field.inputs ?? [];
  const draft = values ?? {};

  return (
    <div className="flex w-full gap-2">
      {inputs.map((input, index) => {
        const prevInput = inputs[index - 1];
        const nextInput = inputs[index + 1];
        const minDate = prevInput ? (draft[prevInput.key] as string | undefined) : undefined;
        const maxDate = nextInput ? (draft[nextInput.key] as string | undefined) : undefined;

        return (
          <div key={input.key} className="flex-1">
            <DateInput
              placeholder={input.label}
              value={(draft[input.key] as string) ?? ""}
              min={minDate}
              max={maxDate}
              onChange={(next) => onChangeField?.(input.key, next || undefined)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PeriodFilterField;
